import { Action, applyMiddleware, combineReducers, createStore, Reducer } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk, { ThunkDispatch } from "redux-thunk";

import { AuthenticationReducers, IAuthenticationReduxState } from "../modules/auth/ui/state/state";
import { BudgetHistoryReducers, IBudgetHistoryReduxState } from "../modules/budget_history/ui/state/state";
import { BudgetReducers, IBudgetReduxState } from "../modules/budget/ui/state/state";
import { ClientHistoryReducers, IClientHistoryReduxState } from "../modules/client_history/ui/state/state";
import { ClientReducers, IClientReduxState } from "../modules/client/ui/state/state";
import { ExpenseReducers, IExpenseReduxState } from "../modules/expense/ui/state/state";
import { IProductHistoryReduxState, ProductHistoryReducers } from "../modules/product_history/ui/state/state";
import { IProductReduxState, ProductReducers } from "../modules/product/ui/state/state";
import { IProfileReduxState, ProfileReducers } from "../modules/profile/ui/state/state";
import { ITransactionReduxState, TransactionReducers } from "../modules/transaction/ui/state/state";
import { IUserReduxState, UserReducers } from "../modules/user/ui/state/state";
import { confirmationMiddleware, reduxPromiseMiddleware } from "./middlewares";

export interface IAppReduxState {
  auth: IAuthenticationReduxState;
  user: IUserReduxState;
  profile: IProfileReduxState;
  product: IProductReduxState;
  productHistory: IProductHistoryReduxState;
  client: IClientReduxState;
  clientHistory: IClientHistoryReduxState;
  expense: IExpenseReduxState;
  transaction: ITransactionReduxState;
  budget: IBudgetReduxState;
  budgetHistory: IBudgetHistoryReduxState;
}

export function getRootReducer(): Reducer<IAppReduxState> {
  const reducersList = {
    auth: AuthenticationReducers,
    user: UserReducers,
    profile: ProfileReducers,
    product: ProductReducers,
    productHistory: ProductHistoryReducers,
    client: ClientReducers,
    clientHistory: ClientHistoryReducers,
    expense: ExpenseReducers,
    transaction: TransactionReducers,
    budget: BudgetReducers,
    budgetHistory: BudgetHistoryReducers,
  };

  return combineReducers<IAppReduxState>(reducersList);
}

export const store = createStore(
  getRootReducer(),
  composeWithDevTools(applyMiddleware(thunk, reduxPromiseMiddleware, confirmationMiddleware)),
);

export type ReduxDispatch = ThunkDispatch<IAppReduxState, any, Action>;
